import React from 'react';
import { PageSEO } from '../PageSEO';
import { LegalPageLayout } from './LegalPageLayout';

/**
 * Terms of Service — Phase 99A.2 light direction.
 *
 * Legal text preserved verbatim. Only chrome migrated to LegalPageLayout.
 */
export const TermsOfService = () => (
  <>
    <PageSEO
      title="Terms of Use — GP Capital"
      description="Terms governing public use of the GP Capital website and marketing pages. Operated by GP CAP Pty Ltd (ACN 665 155 608)."
      path="/terms"
      referrerPolicy="strict-origin"
    />
    <LegalPageLayout
      eyebrow="Legal"
      titleLead="Website terms"
      titleAccent="of use."
      lastUpdated="Last updated: 11 February 2026"
      testId="terms-page"
      relatedLinks={[
        { to: '/privacy', label: 'Privacy Policy', testId: 'privacy' },
        { to: '/platform-terms', label: 'Platform Terms', testId: 'platform-terms' },
        { to: '/disclosures', label: 'Disclosures', testId: 'disclosures' },
        { to: '/security', label: 'Security & Responsible Disclosure', testId: 'security' },
        { to: '/trust', label: 'Trust Center', testId: 'trust' },
      ]}
    >
      <p>
        These Terms of Service (&quot;<strong>Terms</strong>&quot;) govern your access to and use of GP Capital&apos;s website and related services (the &quot;<strong>Services</strong>&quot;). By accessing or using the Services, you agree to these Terms.
      </p>

      <h2>1) Operator details</h2>
      <p>
        The Services are operated by <strong>GP CAP Pty Ltd</strong> (ACN 665 155 608) operating as <strong>GP Capital</strong> (&quot;we&quot;, &quot;us&quot;, &quot;our&quot;).
      </p>

      <h2>2) Intended audience; jurisdiction</h2>
      <p>
        The Services are intended for persons who can lawfully access them. Where content relates to private funding or investment mandates, it is intended for <strong>institutional, professional, wholesale, accredited, or otherwise eligible counterparties</strong>, as applicable.
      </p>
      <p>
        You are responsible for ensuring your access is permitted under the laws of your jurisdiction.
      </p>

      <h2>3) No offer; no advice</h2>
      <p>
        The Services and all content are provided for <strong>general information</strong> only and do not constitute:
      </p>
      <ul>
        <li>an offer, solicitation, or invitation to buy or sell any security, fund interest, or financial product; or</li>
        <li>financial product advice, investment advice, legal advice, tax advice, or credit advice.</li>
      </ul>
      <p>Any transaction is subject to eligibility, diligence, approvals and definitive documentation.</p>

      <h2>4) Acceptable use</h2>
      <p>You must not:</p>
      <ul>
        <li>interfere with the Services or security, or attempt unauthorised access,</li>
        <li>scrape, harvest, or systematically extract data without written permission,</li>
        <li>introduce malware or misuse forms/communications,</li>
        <li>use the Services unlawfully or in a way that infringes rights of others.</li>
      </ul>
      <p>We may suspend or restrict access where we reasonably believe misuse has occurred.</p>

      <h2>5) Intellectual property</h2>
      <p>
        All content (including text, logos, trademarks, graphics, and design) is owned by or licensed to GP Capital. You may view and print content for internal, non-commercial use only, unless agreed otherwise in writing.
      </p>

      <h2>6) Third-party links</h2>
      <p>
        We may link to third-party sites. We do not control or endorse them and are not responsible for their content or practices.
      </p>

      <h2>7) Disclaimers</h2>
      <p>
        To the maximum extent permitted by law, the Services are provided &quot;as is&quot; and &quot;as available.&quot; We do not warrant accuracy, completeness, reliability, or availability.
      </p>

      <h2>8) Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, GP Capital and its affiliates will not be liable for indirect, incidental, special, consequential, or punitive losses, or loss of profit, revenue, goodwill, data, or opportunity arising out of or related to the Services. Where liability cannot be excluded, it is limited to the minimum extent permitted by law.
      </p>

      <h2>9) Indemnity</h2>
      <p>
        You agree to indemnify GP Capital for losses, liabilities, costs, and expenses (including reasonable legal fees) arising from your breach of these Terms or misuse of the Services.
      </p>

      <h2>10) Privacy</h2>
      <p>
        Use of the Services is also governed by our <a href="/privacy">Privacy Policy</a>.
      </p>

      <h2>11) Changes</h2>
      <p>
        We may update these Terms by posting a revised version on this page. Continued use after changes means you accept the updated Terms.
      </p>

      <h2>12) Governing law</h2>
      <p>
        These Terms are governed by the laws of the applicable jurisdiction, and you submit to the non-exclusive jurisdiction of courts in that jurisdiction, subject to any mandatory laws.
      </p>

      <h2>13) Contact</h2>
      <p>
        Questions about these Terms: <a href="mailto:info@gp-cap.com">info@gp-cap.com</a>
      </p>
    </LegalPageLayout>
  </>
);

export default TermsOfService;
